import React from "react";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import { Controller } from "react-hook-form";

interface IProps {
  name: string;
  error?: any;
  label?: string;
  control: any;
  isRequired?: boolean;
  disabled?: boolean;
  type?: string;
  isClearable?: boolean;
  options: any[];
  placeholder?: string;
}

const MultiSelectField = React.forwardRef<HTMLInputElement, IProps>((props: IProps, ref) => {
  const {
  name,
  placeholder,
  error,
  label,
  options,
  control,
  isClearable,
  isRequired = false,
  disabled = false,
} = props;

  return (
    <FormControl fullWidth>
      <Controller
        render={({ field }) => (
          <Autocomplete
            {...field}
            onChange={(event, value) => field.onChange(value)}
            multiple
            options={options}
            getOptionLabel={(option) => option?.label}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            value={field.value || []}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                error={!!error}
                helperText={error ? error.message : null}
                label={label}
                placeholder={options?.length ? "" : placeholder}
                inputProps={{
                  ...params.inputProps,
                  ...{
                    "data-testid": field.name,
                  },
                }}
                InputLabelProps={{
                  required: isRequired
                }}
              />
            )}
          />
        )}
        name={name}
        control={control}
      />
    </FormControl>
  );
});

MultiSelectField.defaultProps = {
  isRequired: false,
  disabled: false,
};

export { MultiSelectField };